// extracted by mini-css-extract-plugin
export var contentBody = "_5e-9";
export var headerImage = "_5e-2";
export var imageButton = "_5e-7";
export var imageButtonIcon = "_5e-8";
export var imageHeader = "_5e-4";
export var imageHeaderText = "_5e-5";
export var imageOverlay = "_5e-3";
export var imageTitle = "_5e-6";
export var imageWrapper = "_5e-1";
export var taskList = "_5e-a";
export var widget = "_5e-0";